import React from 'react';
import {Button} from "reactstrap";


export class MyButton extends React.Component {
  render() {
    return <Button className="mb-2 me-2" {...this.props} />
  }
}
